export default __webpack_public_path__ + "static/hero-a9a84fc448fd01b8134396ec7606aac9.svg";